import React from 'react';
import PropTypes from 'prop-types';

import useStore from '../../_global/jsx/store.js';
import shallow from 'zustand/shallow';
import { InfoCircle } from '../../SVGs/svg.imports.js';

const RadioOptions = props => {

    const { matrixData, setOptionSelectionId, setChecked, setShowOptionTooltipModal, setTooltipContent } = useStore(state =>({
        matrixData: state.matrixData,
        setOptionSelectionId: state.setOptionSelectionId,
        setChecked: state.setChecked,
        setShowOptionTooltipModal: state.setShowOptionTooltipModal,
        setTooltipContent: state.setTooltipContent,
    }), shallow);

    let children = matrixData['pages'][props.pageId]['children'];

    const clickOption = (e) =>{
        setChecked(e.target.id);
        setOptionSelectionId(e.target.id)
    }

    const openOptionTooltip = (e) => {
        setShowOptionTooltipModal(true);
        const id = e.currentTarget.dataset.id;
        const optionTooltip = matrixData['pages'][id]['option_displayed_on_parent_tooltip'];
        setTooltipContent(optionTooltip);
    }

    const optionsListing =  children.map((item) => {
        const optionTooltip = matrixData['pages'][item]['option_displayed_on_parent_tooltip'];

        return (
            <div 
                className="step_option--radio"
                key={item}
            >
                    <input onClick={clickOption} type="radio" id={item} name="common" />
                    <label htmlFor={item}>
                        {matrixData['pages'][item]['option_displayed_on_parent']}
                        {optionTooltip ? <button role="button" onClick={openOptionTooltip}  className="option_tooltip" data-id={item}><InfoCircle /></button> : ''}
                    </label>   
                    
            </div>
        )
    })

  return (
    <div className="step_options step_options--radio">
        {optionsListing}
    </div>
  )
}

RadioOptions.propTypes = {
    pageId: PropTypes.string
}

export default RadioOptions